import { render, staticRenderFns } from "./RequestViewGallery.vue?vue&type=template&id=2d7c46c8"
import script from "./RequestViewGallery.vue?vue&type=script&lang=js"
export * from "./RequestViewGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports